import { useState } from "react";
import servicosCargo from "../../servicos/servicos-cargo";
import MenuLateral from "./MenuLateral";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import NavMenu from "./Nav";
import Salvar from "../../img/svgs/Salvar";

const dadosCargo = {
    'nome_cargo': ''
}

const CadastroCargo = () => {
    const [data, setData] = useState(dadosCargo);
    const { register, handleSubmit, formState: { errors } } = useForm();

    const criarCargo = () => {
           servicosCargo.create(data)
                .then(response => {
                    if (response.status === 201) {
                        toast.success("Cargo adicionado com sucesso!",{
                            theme: "colored",
                        });
                        clearData();
                    }
                })
                .catch(e => {
                    toast.error("Não foi possível cadastrar o Cargo!", {
                        theme: "colored"
                    });
                    console.log(e);
                })
        
    }

    const clearData = () => {
        const nome = document.querySelector('#nome_cargo');
        nome.value = '';
    }
    const handleChange = (e) => {
        let { name, value } = e.target;
        setData({ ...data, [name]: value });
    }

    return <>
        <NavMenu />
        <ToastContainer />
        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>
            <div className="w-75 mt-4">
                    <form className="cadastros" onSubmit={handleSubmit(criarCargo)}>
                        <Form.Group className="mb-3" controlId="nome_cargo">
                            <Form.Label className="label-texto">Cargo</Form.Label>
                            <Form.Control
                                className="input-cadastro"
                                type="text"
                                name="nome_cargo"
                                {...register("nome_cargo", { required: true, minLength: 2 })}
                                onChange={handleChange} 
                            />
                        </Form.Group>
                        {errors.nome_cargo && <p className="errosValidacao">Requerido mínimo 2 letras</p>}
                        <button type="submit" className="btn btn-icones"><Salvar /><span className="pt-1"> Salvar</span></button>
                    </form>
            </div>
        </div>
    </>
}

export default CadastroCargo;